import { action, observable, makeObservable } from 'mobx';
import { AssignedUserLevel } from 'typings/enums';

export class RemoveAssignedUserStore {
    @observable _assignedUserId: Nullable<string>;
    @observable _assignedUserLevel: Nullable<AssignedUserLevel>;
    @observable _accessGroupDisplayName: Nullable<string>;

    constructor() {
        makeObservable(this);
    }

    get assignedUserLevel(): string {
        return this._assignedUserLevel?.toString() ?? '';
    }

    @action
    showRemoveAssignedUserWarningBox(
        assignedUserId: string,
        assignedUserlevel: AssignedUserLevel,
        accessGroupDisplayName?: string
    ): void {
        this._assignedUserId = assignedUserId;
        this._assignedUserLevel = assignedUserlevel;
        if (accessGroupDisplayName) {
            this._accessGroupDisplayName = accessGroupDisplayName;
        }
    }

    @action
    unsetAssignedUser(): void {
        this._assignedUserId = null;
        this._assignedUserLevel = null;
        this._accessGroupDisplayName = null;
    }
}